import cubejs from '@cubejs-client/core';
import { QueryRenderer } from '@cubejs-client/react';
import { Spin } from 'antd';
import 'antd/dist/antd.css';
import React from 'react';
import { Bar } from 'react-chartjs-2';

import { cubejsApiTokenPromise, cubejsOptions } from './cube-config';

const COLORS_SERIES = ['#00ad99', '#141446', '#7A77FF'];
const commonOptions = {
  maintainAspectRatio: true,
};

const cubejsApi = cubejs(
  cubejsApiTokenPromise,
  cubejsOptions
);


const renderChart = ({ resultSet, error }) => {
    if (error) {
        return <div>{error.toString()}</div>;
    }

    if (!resultSet) {
        return <Spin />;
    }

    const data = {
      labels: resultSet.categories().map((c) => c.category),
      datasets: resultSet.series().map((s, index) => ({
          label: s.title,
          data: s.series.map((r) => r.value),
          backgroundColor: COLORS_SERIES[index],
          fill: false
      })),
    };
    const options = {
        ...commonOptions,
        scales: {
            xAxes: [{
                stacked: true,
                title: "time",
                type: 'time',
                gridLines: {
                    lineWidth: 1
                },
                time: {
                    unit: "month",
                    displayFormats: {
                        month: 'MMM-YY',
                        quarter: 'MMM-YY',
                        year: 'MMM-YY',
                    }
                }
                },
            ],
              yAxes: [{
                  stacked: true
              }]
          },
    };
    return <Bar data={data} options={options}  />;

};

const ChartCantidadPorEstado = () => {
  return (
    <QueryRenderer
      query={{
          "measures": [
            "HistoricoValidaciones.count"
          ],
          "timeDimensions": [
            {
              "dimension": "HistoricoValidaciones.fechaPrestacion",
              "granularity": "month"
            }
          ],
          "order": {
            "HistoricoValidaciones.count": "desc"
          },
          "dimensions": [
            "HistoricoValidaciones.estado"
          ]
        }}
      cubejsApi={cubejsApi}
      resetResultSetOnChange={false}
      render={(props) => renderChart({
        ...props,
        chartType: 'bar',
        pivotConfig: {
          "x": [
            "HistoricoValidaciones.estado",
            "HistoricoValidaciones.fechaPrestacion.month"
          ],
          "y": [
            "measures"
          ],
          "fillMissingDates": true,
          "joinDateRange": false
        }
      })}
    />
  );
};
      
export default ChartCantidadPorEstado;
//const rootElement = document.getElementById('root');
//ReactDOM.render(<ChartCantidadPorEstado />, rootElement);
      